<template>
    <CompassTable class="activities-listing-table--loading" :border="border" size="large">
        <CompassTableHead>
            <CompassTableHeadCell
                v-for="(column, index) in colsHeader"
                :key="index"
                :width="column.width"
            >
                <CompassSkeleton :variant="column.skeleton.variant" :size="column.skeleton.size" />
            </CompassTableHeadCell>
        </CompassTableHead>
        <CompassTableBody>
            <CompassTableRow v-for="(_, indexRow) in 24" :key="indexRow">
                <CompassTableBodyCell v-for="(column, indexCol) in colsBody" :key="indexCol">
                    <CompassSkeleton
                        :variant="column.skeleton.variant"
                        :size="column.skeleton.size"
                    />
                </CompassTableBodyCell>
            </CompassTableRow>
        </CompassTableBody>
    </CompassTable>
</template>

<script>
export default {
    props: {
        border: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            colsHeader: [
                {
                    width: '48px',
                    skeleton: {
                        variant: 'square',
                        size: 'small',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        variant: 'line',
                        size: 'medium',
                    },
                },
                {
                    width: '82px',
                    skeleton: {
                        size: 'medium',
                        variant: 'square',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        size: 'medium',
                        variant: 'line',
                    },
                },
                {
                    width: '82px',
                    skeleton: {
                        size: 'medium',
                        variant: 'square',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        variant: 'line',
                        size: 'medium',
                    },
                },
            ],
            colsBody: [
                {
                    width: '48px',
                    skeleton: {
                        variant: 'square',
                        size: 'small',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        size: 'medium',
                        variant: 'line',
                    },
                },
                {
                    width: '82px',
                    skeleton: {
                        size: 'medium',
                        variant: 'square',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        size: 'medium',
                        variant: 'line',
                    },
                },
                {
                    width: '82px',
                    skeleton: {
                        size: 'medium',
                        variant: 'square',
                    },
                },
                {
                    width: '372px',
                    skeleton: {
                        size: 'medium',
                        variant: 'line',
                    },
                },
            ],
        };
    },
};
</script>

<style scoped lang="scss">
.activities-listing-table--loading::v-deep {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    .compass-table__row:hover {
        & > td,
        & > th {
            background-color: var(--colors-common-background-default);
        }
    }
    .compass-table-head__cell {
        .compass-skeleton__line {
            width: 50px;
        }
    }
}
</style>
